export default __webpack_public_path__ + "static/media/manage_empty.0a05c478.svg";